const addProj = () => import('./addProj.vue');
const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin.vue');
const edit = () => import('./edit.vue');

//云南省先进制造业股权投资基金
export default {
  routes: [
    {
      path: '/equityInvestment/v2025/indexApp',
      name: 'equityInvestment_v2025_index_App',
      component: indexApp,
      meta: {public: true}
    },
    {
      path: '/equityInvestment/v2025/indexAdmin',
      name: 'equityInvestment_v2025_index_Admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/equityInvestment/v2025/addProj',
      name: 'equityInvestment_v2025_add_proj',
      component: addProj,
      meta: {public: true}
    },
    {
      path: '/equityInvestment/v2025/edit',
      name: 'equityInvestment_v2025_edit',
      component: edit,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/equityInvestment/V2025/router.js